<template>
    <div class="more-btn">
        <div class="label">
            <div>
                <span
                    v-text="content"
                    style="position: relative;top: -12px;"
                ></span>
                <img
                    src="@/assets/img/icon/u414.png"
                    style="position: relative;top: -12px;"
                />
            </div>
        </div>
        <div class="dropdown">
            <!-- 下拉框 -->
            <div class="default-dropdown">
                <slot name="down"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "customizeDown",
    props: {
        content: {
            type: String,
            default: "更多"
        }
    }
};
</script>

<style lang="scss" scoped>
.more-btn {
    display: inline-block;
    position: relative;
    height: 0px;
    margin-left: 6px;
    z-index: 4;
    &:hover {
        z-index: 5;
        .dropdown {
            visibility: visible;
            z-index: 5;
            .default-dropdown {
                top: 0px;
            }
        }
    }
    .label {
        vertical-align: top;
        cursor: pointer;
        height: 16px;
        line-height: 16px;
        img {
            position: relative;
            // top: -21px;
            left: 3px;
        }
    }
    .dropdown {
        position: absolute;
        left: -10px;
        top: -4px;
        padding: 10px;
        visibility: hidden;
        overflow: hidden;
        width: 220px;
        .default-dropdown {
            top: -220px;
            left: 0px;
            min-width: 220px;
        }
    }
}
</style>
